import React,{useState,useEffect} from "react";
import { Modal,Form, Input, Button, Checkbox, Table } from "antd";

import { useSelector } from 'react-redux'
import { Footer } from "antd/lib/layout/layout";



const { TextArea } = Input;

export default function CateringItems(props) {
  
 

  const adminRestaurant = useSelector((state) => state.admin)

  const columns = [
    {
      title: "Completed",
      dataIndex: "name",
      key: "name",
    //   width: 200,
      render: (e, record) => (
        <div className="image-name">
          <Checkbox defaultChecked={record.current_status == "FULFILLED"?true:false} disabled />
       
        </div>
      ),
    },
    {
      title: "Item Name",
     
      render:(_, record)=> <div>{record.menu_item?.name}</div>
    },
    {
      title: "Quantity",
     
      render:(_, record)=> <div>{record.quantity}</div>
    },
    {
        title: "Total Price",
      
        render:(_, record)=> <div>{record.price}</div>
      },

  ];

 


    return (
        <Modal width={695}  visible={props.modalOpen} footer={null} onCancel={()=>props.closeModal(false)} className="catering-item-modal">
              <Table className="catering-items-table" columns={columns} dataSource={props.cateringItems?.catering_request_items} 
              pagination={false}
         
        />
        <Footer className="order-footer">
<div className="total-price-orders">Total Price     ${props.cateringItems?.catering_request_items?.map(item=>item.price)?.reduce((a, b) => a + b, 0)}</div>
        </Footer>
     
      </Modal>
    );
  }





